import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export interface Notifications {
  isOpen: boolean;
  isNotRead: number;
}

const initialState: Notifications = {
  isOpen: false,
  isNotRead: 0,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setIsnotRead: (state, action: PayloadAction<number>) => {
      state.isNotRead = action.payload;
    },
    incrementIsNotRead: (state) => {
      state.isNotRead += 1;
    },
  },
});

export const { setIsOpen, setIsnotRead, incrementIsNotRead } =
  notificationSlice.actions;
export const isOpen = (state: RootState) => state.notifications.isOpen;
export const isNotRead = (state: RootState) => state.notifications.isNotRead;
export default notificationSlice.reducer;
